/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Param_Source_InvalidInputs */

const vi_error_zns_param_source_invalid = /** @type {(inputs: Error_Zns_Param_Source_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nguồn dữ liệu không hợp lệ cho mục đích này — chọn lại nguồn, hoặc chỉ chọn một trong nguồn ERP / giá trị cố định.`)
};

/**

* @param {Error_Zns_Param_Source_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_param_source_invalid = /** @type {((inputs?: Error_Zns_Param_Source_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Param_Source_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_param_source_invalid(inputs)
});